export default __webpack_public_path__ + "static/media/Beastclaw.1f295996.jpg";